import { DraftConfiguration, Size } from '@/types';
import { getOffsetAfterResize } from '@/model/configuration/getOffsetAfterResize';
import { scaleSize } from '@/model/configuration/scaleSize';

export const updateSizeAndOffset = (
  configuration: DraftConfiguration,
  newSize: Size,
  newScale = configuration.scale
) => {
  configuration.offset = getOffsetAfterResize(
    configuration.offset,
    scaleSize(configuration.size, configuration.scale),
    scaleSize(newSize, newScale),
    configuration.printArea
  );
  configuration.scale = newScale;
  configuration.size = newSize;
};
